import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Emergency from './pages/Emergency';
import ServiceAreas from './pages/ServiceAreas';
import Financing from './pages/Financing';
import RequestService from './pages/RequestService';
import Contact from './pages/Contact';

function App() {
  return (
    <Router basename="/projects/blueflow-plumbing">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="about" element={<About />} />
          <Route path="emergency" element={<Emergency />} />
          <Route path="areas" element={<ServiceAreas />} />
          <Route path="financing" element={<Financing />} />
          <Route path="request-service" element={<RequestService />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
